import { ELATION_PATIENT_BASE_URL } from '../config/medical-constants';

// ?goto=elation → the Elation chart URL, resolved here (behind auth, trusted server data) so the
// deep link never has to carry the ehr_patient_id. null = don't redirect (wrong param / no chart).
export function elationRedirectHref(gotoParam: string | null, ehrPatientId: unknown): string | null {
  if (gotoParam !== 'elation') return null;
  if (ehrPatientId === null || ehrPatientId === undefined || ehrPatientId === '') return null;
  return `${ELATION_PATIENT_BASE_URL}/${ehrPatientId}/`;
}
